import React from 'react';
import ReactDOM from 'react-dom/client';
// Two type voices, self-hosted (no external CDN): Fraunces is the "art" voice
// (wordmark + hero), IBM Plex Mono is the "mathematics" voice (coordinates, IDs,
// UI). See App.css for how they're assigned.
import '@fontsource/fraunces/300.css';
import '@fontsource/fraunces/400.css';
import '@fontsource/fraunces/600.css';
import '@fontsource/ibm-plex-mono/400.css';
import '@fontsource/ibm-plex-mono/500.css';
import '@fontsource/ibm-plex-mono/600.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';

// NOTE: Auth0Provider has no `onError` prop — not in Auth0ProviderOptions and not
// in Auth0ClientOptions. One used to be passed here and was silently ignored, so a
// failed login looked identical to no login at all: no error page, no console, no
// session. Auth errors arrive on `error` from useAuth0(); NavBar reports them.

// When REACT_APP_AUTH0_AUDIENCE is set, Auth0 issues a verifiable RS256 JWT for
// that API and the Block I backend switches on (see src/api.js — the same
// variable gates the client). Left unset, login stays identity-only and the
// gallery stays anonymous in localStorage, exactly as Block H shipped it.
const audience = process.env.REACT_APP_AUTH0_AUDIENCE;
const authorizationParams = {
  redirect_uri: window.location.origin,
  ...(audience
    ? {
        audience,
        // Asked for so Auth0 will issue a refresh token; see below for why.
        scope: 'openid profile email offline_access',
      }
    : {}),
};

// SAFARI. Without these, getAccessTokenSilently() renews the access token in a
// hidden iframe using a third-party cookie — which Safari's ITP blocks outright
// on iOS and macOS. The failure is not subtle and not rare: it is every
// signed-in iPhone visitor's gallery failing to load once the initial token
// expires, on the device this product is most used from.
//
// Refresh tokens avoid the iframe entirely, which means storing one where a page
// reload can find it. That is a real trade-off (localStorage is readable by any
// XSS on the origin) and it is taken deliberately, with refresh token ROTATION
// enabled on the Auth0 API so a stolen token is single-use and its reuse is
// detectable. Only enabled alongside the audience, since there is no API to hold
// a token for otherwise.
const tokenStorage = audience
  ? { useRefreshTokens: true, cacheLocation: 'localstorage' }
  : {};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Auth0Provider
      domain={process.env.REACT_APP_AUTH0_DOMAIN}
      clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
      authorizationParams={authorizationParams}
      {...tokenStorage}
    >
      <App />
    </Auth0Provider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
